import * as React from "react";
import Axios from "axios";
import QRCode from "qrcode";
import Barcode from "react-barcode";
import { useNavigate, useParams } from "react-router-dom";
import {
  Box,
  Card,
  Grid,
  CardMedia,
  Button,
  Dialog,
  DialogContent,
  IconButton,
} from "@mui/material";
import Typography from "@mui/material/Typography";
import ToggleButton from "@mui/material/ToggleButton";
import ToggleButtonGroup from "@mui/material/ToggleButtonGroup";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import CloseIcon from "@mui/icons-material/Close";

import { useTranslation } from "react-i18next";

import Layout from "./Layout/Layout";

import "./MyReward.css";

async function getMyRewardList(id) {
  try {
    let result = await Axios.get(
      `${process.env.REACT_APP_BACKEND_DOMAIN_API}/game_web/my_profile/my_reward_list/${id}`,
      {
        headers: {
          "Content-Type": "application/json",
          "x-api-key": process.env.REACT_APP_X_API_KEY,
          "x-access-token": sessionStorage.getItem("accessToken"),
        },
      }
    );
    return result.data;
  } catch (error) {
    console.log(`bigc-line-coupon-web: ${error}`);
    return {
      status: "failed",
      message: error.message,
    };
  }
}

async function welcomePack() {
  try {
    let result = await Axios.get(
      `${process.env.REACT_APP_BACKEND_DOMAIN_API}/game_web/reward/common_welcome_pack`,
      {
        headers: {
          "Content-Type": "application/json",
          "x-api-key": process.env.REACT_APP_X_API_KEY,
          "x-access-token": sessionStorage.getItem("accessToken"),
        },
      }
    );
    if (result.data.status === "success") {
      return result.data;
    } else {
      return { message: "failed" };
    }
  } catch (error) {
    console.log(`bigc-cms-line-coupon: ${error}`);
    return { message: "failed" };
  }
}

export default function MyReward() {
  const { t } = useTranslation();
  //const [isLang, setIsLang] = React.useState("en");
  const [alignment, setAlignment] = React.useState("barcode");
  const [qr, setQr] = React.useState("");

  const [myRewardList, setMyRewardList] = React.useState([]);
  const [couponRegisterList, setCouponRegisterList] = React.useState([]);
  const [selectedReward, setSelectedReward] = React.useState({});
  const [innerWidth, setInnerWidth] = React.useState(window.innerWidth);
  let navigate = useNavigate();
  const userId = sessionStorage.getItem("userId");
  const passport = sessionStorage.getItem("passport");
  const [open, setOpen] = React.useState(false);

  let rewardItems = [];
  let { lang } = useParams();

  React.useEffect(() => {
    async function fetchData() {
      let myReward = [];

      //await setIsLang(sessionStorage.getItem("lang"));
      const myRewardListData = await getMyRewardList(userId);
      if (myRewardListData.status === "success") {
        if (myRewardListData.data.length > 0) {
          myReward = [...myReward, ...myRewardListData.data];
        }
      }
      const myRewardWelcomePack = await welcomePack();
      if (myRewardWelcomePack.data) {
        rewardItems = myRewardWelcomePack.data.map((val, index) => {
          myReward = [...myReward, ...val.reward_list];
        });
      }
      setMyRewardList(myReward);
    }
    fetchData();
  }, []);

  const handlePopup = async (e, value) => {
    e.preventDefault();
    if (value.ga_track_id === "ga-lucky-voucher-300b") {
      window.fbq("trackCustom", "click_coupon300");
      window.ttq.track("InitiateCheckout");
    }
    await GenerateQRCode(value.reward_code);
    setOpen(true);
    await setSelectedReward(value);
  };

  const handleClose = (e) => {
    e.preventDefault();
    setOpen(false);
  };

  const handleChangeLang = (e, newLang) => {
    e.preventDefault();
    if (lang != newLang) {
      window.location.href = `/${newLang}/my-reward`;
    }
  };

  const handleBack = (e, lang) => {
    e.preventDefault();
    //navigate(-1);
    window.location.href = `/${lang}/lobby`;
  };

  const handleChange = (event, newAlignment) => {
    event.preventDefault();
    setAlignment(newAlignment);
  };

  const GenerateQRCode = (couponCodeData) => {
    QRCode.toDataURL(
      couponCodeData,
      {
        width: 280,
        margin: 2,
      },
      (err, res) => {
        if (err) return console.error(err);
        setQr(res);
      }
    );
  };

  if (myRewardList.length > 0) {
    rewardItems = myRewardList.map((val, index) => {
      return (
        <Grid
          item
          sm={12}
          xs={12}
          key={`game_` + index}
          className={`my-reward-list ga-popup-rewawrd ${val.ga_track_id}`}
          onClick={(e) => handlePopup(e, val)}
        >
          <Grid
            container
            spacing={1}
            justify="flex-end"
            alignItems="center"
            className={`${val.ga_track_id}`}
          >
            <Grid item xs={6} sm={3}>
              <CardMedia
                className={`box-my-reward-img ${val.ga_track_id}`}
                component="img"
                id={`img-${val.ga_track_id}`}
                image={
                  lang === "cn" ? val.reward_cover_cn : val.reward_cover_en
                }
                alt="reward"
              />
            </Grid>
            <Grid item xs={6} sm={9}>
              <Box className="box-my-reward-detail">
                <Typography
                  variant="h6"
                  className={`my-reward-name ${val.ga_track_id}`}
                  id={`name-${val.ga_track_id}`}
                >
                  {lang === "cn" ? val.reward_name_cn : val.reward_name_en}
                </Typography>
                {val.expire_date != null?(
                <Typography
                  variant="body"
                  className={`my-reward-expire ${val.ga_track_id}`}
                >
                   {t("expire_date")} : {val.expire_date}
                </Typography>
                ):""}
                {/*<Typography variant="body" className="my-reward-name">
                  {lang === "cn" ? val.reward_detail_cn : val.reward_detail_en}
              </Typography>*/}
              </Box>
            </Grid>
          </Grid>
        </Grid>
      );
    });
  }
  return (
    <Layout>
      <Box sx={{ minHeight: 800, width: "100%", boxShadow: "none" }}>
        <Box sx={{ m: 2 }}>
          <Grid container spacing={1}>
            <Grid item sm={12} xs={12}>
              <Box className="my-reward-box-main">
                <Grid container spacing={1} alignItems="center">
                  <Grid item xs={6} sm={6}>
                    <Box className="lobby-box-reward">
                      <Box className="my-btn-reward ">
                        <Button
                          sx={{ color: "#fff" }}
                          onClick={(e) => handleBack(e, lang)}
                          startIcon={<ArrowBackIcon />}
                        >
                          {t("btn_Back")}
                        </Button>
                      </Box>
                    </Box>
                  </Grid>

                  <Grid item xs={6} sm={6}>
                    <Box className="lobby-box-len">
                      <Box className="lobby-btn-len">
                        <Button
                          className={
                            lang === "en" ? "active radiusLeft" : "radiusLeft"
                          }
                          sx={{ color: "#fff", float: "left" }}
                          onClick={(e) => handleChangeLang(e, "en")}
                        >
                          EN
                        </Button>
                        <Button
                          className={
                            lang === "cn" ? "active radiusRight" : "radiusRight"
                          }
                          sx={{ color: "#fff" }}
                          onClick={(e) => handleChangeLang(e, "cn")}
                        >
                          中文
                        </Button>
                      </Box>
                    </Box>
                  </Grid>
                  <Grid item xs={12} sm={12}>
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "center",
                        width: "100%",
                      }}
                    >
                      <Box className="box-header-my-reward">
                        <Typography variant="h4" className="award-name">
                          {t("header_My_Reward")}
                        </Typography>
                      </Box>
                    </Box>
                  </Grid>
                  <Grid item sm={12} xs={12}>
                    <Box
                      className="render-paper-box"
                      sx={{ pt: 2, pl: 2, pr: 2, pb: 10 }}
                    >
                      {rewardItems}
                      <Box className="my-reward-list"></Box>
                    </Box>
                  </Grid>
                </Grid>
              </Box>
            </Grid>
          </Grid>
        </Box>
      </Box>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        scroll="body"
      >
        <DialogContent className="box-my-reward-dialog" sx={{ maxWidth: 400 }}>
          <Grid container spacing={1}>
            <Grid item sm={12} xs={12}>
              <Box className="policy-header-close">
                <IconButton onClick={handleClose} sx={{ r: 0 }}>
                  <CloseIcon />
                </IconButton>
              </Box>
              <CardMedia
                className="box-award-dialog-img"
                component="img"
                image={
                  lang === "cn"
                    ? selectedReward.reward_cover_cn
                    : selectedReward.reward_cover_en
                }
                alt="reward"
              />
            </Grid>
            {selectedReward.is_expire ==='yes'?(
              <Box
              className="box-expire-dialog-img"
              component="img"
              src="/img/expired.png"
            />

            ):(
            selectedReward.reward_code != 0 ? (
              <>
                <Grid item sm={12} xs={12}>
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "center",
                      width: "100%",
                      mt: 2,
                      mb: 1,
                    }}
                  >
                    <ToggleButtonGroup
                      color="primary"
                      value={alignment}
                      exclusive
                      onChange={handleChange}
                      aria-label="Platform"
                      sx={{ width: "80%" }}
                    >
                      <ToggleButton value="barcode" sx={{ width: "50%" }}>
                        BAR CODE
                      </ToggleButton>
                      <ToggleButton value="qrcode" sx={{ width: "50%" }}>
                        QR CODE
                      </ToggleButton>
                    </ToggleButtonGroup>
                  </Box>
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "center",
                      width: "100%",
                      mb: 2,
                    }}
                    className="QR-Box"
                  >
                    {alignment === "qrcode" ? (
                      <Card>
                        <img src={qr} />
                      </Card>
                    ) : (
                      <Card>
                        {innerWidth < "370" ? (
                          <Barcode
                            value={selectedReward.reward_code}
                            format="code128"
                            fontSize="10"
                            width="1"
                          />
                        ) : (
                          <Barcode
                            value={selectedReward.reward_code}
                            format="code128"
                            fontSize="20"
                            width="2"
                          />
                        )}
                      </Card>
                    )}
                  </Box>
                </Grid>
              </>
            ) : (
              ""
            )
            )}
            <Grid item sm={12} xs={12}>
              <Box className="box-my-reward-detail">
              <Typography
                  variant="body"
                  component="div"
                  className="my-reward-name"
                >
                #Passport ID : {passport}
                </Typography>
                <Typography
                  variant="h6"
                  component="div"
                  className="my-reward-name"
                >
                  {lang === "cn"
                    ? selectedReward.reward_name_cn
                    : selectedReward.reward_name_en}
                </Typography>
                {selectedReward.expire_date != null?(
                <Typography
                  variant="body"
                  component="div"
                  className={`my-reward-expire-detail`}
                >
                  {t("expire_date")} : {selectedReward.expire_date}
                </Typography>
                ):""}
                <Typography
                  variant="body"
                  component="div"
                  className="my-reward-detail"
                  dangerouslySetInnerHTML={{
                    __html:
                      lang === "cn"
                        ? selectedReward.reward_detail_cn
                          ? selectedReward.reward_detail_cn.replace(
                              /(?:\r\n|\r|\n)/g,
                              "<br />"
                            )
                          : ""
                        : selectedReward.reward_detail_en
                        ? selectedReward.reward_detail_en.replace(
                            /(?:\r\n|\r|\n)/g,
                            "<br />"
                          )
                        : "",
                  }}
                ></Typography>
                <Typography
                  variant="body"
                  component="div"
                  className="my-reward-condition"
                  dangerouslySetInnerHTML={{
                    __html:
                      lang === "cn"
                        ? selectedReward.reward_condition_cn
                          ? selectedReward.reward_condition_cn.replace(
                              /(?:\r\n|\r|\n)/g,
                              "<br />"
                            )
                          : ""
                        : selectedReward.reward_condition_en
                        ? selectedReward.reward_condition_en.replace(
                            /(?:\r\n|\r|\n)/g,
                            "<br />"
                          )
                        : "",
                  }}
                ></Typography>

                <Box className="btn-award">
                  <Button
                    sx={{ color: "#fff" }}
                    onClick={(e) => handleClose(e)}
                  >
                    {t("btn_Close")}
                  </Button>
                </Box>
              </Box>
            </Grid>
          </Grid>
        </DialogContent>
      </Dialog>
    </Layout>
  );
}
